import { render, staticRenderFns } from "./IframeFReportView.vue?vue&type=template&id=45cfa1c6"
import script from "./IframeFReportView.vue?vue&type=script&lang=js"
export * from "./IframeFReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports